import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { navLinks } from "@/mocks/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const term = q.trim();
    navigate(term ? `/search?q=${encodeURIComponent(term)}` : "/");
    setQ("");
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/90 backdrop-blur-md border-b border-background-200">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5" aria-label="吃瓜视频网 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-fire-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              吃瓜视频网
            </span>
            <span className="text-[10px] tracking-[0.2em] text-foreground-400">
              CHIGUA VIDEO
            </span>
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <NavLink
              key={link.href}
              to={link.href}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "text-primary-600"
                    : "text-foreground-700 hover:text-primary-600"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        {/* Right actions */}
        <div className="flex items-center gap-3">
          <form
            onSubmit={submitSearch}
            className="hidden md:flex items-center gap-2 rounded-full bg-background-100 px-3.5 py-2 ring-1 ring-inset ring-background-200 focus-within:ring-primary-300"
            role="search"
          >
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              type="search"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="搜索明星、综艺、影视…"
              className="w-40 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              aria-label="站内搜索"
            />
          </form>
          <Link
            to="/contact"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            我要投稿
          </Link>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 lg:hidden"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto max-w-7xl space-y-1 px-4 py-4">
            <form onSubmit={submitSearch} className="mb-3 flex items-center gap-2 rounded-full bg-background-100 px-3.5 py-2.5 ring-1 ring-inset ring-background-200">
              <i className="ri-search-line text-sm text-foreground-400" />
              <input
                type="search"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="搜索明星、综艺、影视…"
                className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
                aria-label="站内搜索"
              />
            </form>
            <nav className="grid grid-cols-2 gap-1" aria-label="移动端导航">
              {navLinks.map((link) => (
                <NavLink
                  key={link.href}
                  to={link.href}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `rounded-lg px-3 py-2.5 text-sm font-medium ${
                      isActive
                        ? "bg-primary-50 text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}